export default __webpack_public_path__ + "static/media/pfp.4d6d7b13.png";